module.exports = "<div>This is the monitor-tool view.</div>\n<div>I bear this message: {{message}}</div>\n"